import { Checkbox, CheckboxGroup, HStack } from '@chakra-ui/react';
import { ChangeEventHandler } from 'react';

export type TargetReaderType = {
  id: number;
  name: string;
  selected?: boolean;
};

/**
 * 対象読者セレクト（検索絞り込み用）
 */
export default function TargetReaderSelect({
  targetReaderTypes,
  onChange,
}: {
  targetReaderTypes: TargetReaderType[];
  onChange?: ChangeEventHandler<HTMLInputElement>;
}) {
  return (
    <CheckboxGroup colorScheme="green">
      <HStack spacing={1} wrap="wrap" gap={1}>
        {targetReaderTypes.map((targetReader) => (
          <Checkbox
            id={targetReader.id.toString()}
            key={targetReader.id}
            size="sm"
            colorScheme="green"
            bg="searchBar"
            p={2}
            borderRadius="full"
            name={targetReader.name}
            isChecked={targetReader.selected}
            onChange={onChange}
          >
            {targetReader.name}
          </Checkbox>
        ))}
      </HStack>
    </CheckboxGroup>
  );
}
